export default {
      id: "ic-nav-exit-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-exit-usage",
      toString: function () {
        return this.url;
      }
    }